import Button from 'components/Button';
import React, { FC, memo } from 'react';
import { Benefit, Benefits, Check, Container, Footer, Title } from './styles';

const BENEFITS = [
  'On-demand video courses',
  'Office hours',
  'Discounts to SWD sessions',
  'Exclusive video content',
  'Early access',
  'Live virtual events',
];

const PremiumBanner: FC<{ className?: string }> = ({ className }) => (
  <Container className={className}>
    <Title>
      Premium membership:
      <br />a new level of learning and support
    </Title>
    <Benefits>
      {BENEFITS.map((benefit) => (
        <Benefit key={benefit}>
          <Check />
          {benefit}
        </Benefit>
      ))}
    </Benefits>
    <Footer>
      <Button variant="premiumAccent" to="/subscribe">
        Go premium
      </Button>
    </Footer>
  </Container>
);

export default memo(PremiumBanner);
